import './section-card-list.scss';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@sola/ark-core/molecules/tooltip/tooltip.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

export interface SectionCardListProps {
  children: React.ReactNode;
  heading: string;
  subheading?: string;
  tooltipContent?: string;
}

/**
 * Section for Card Lists.
 * In the future, we may want to make this more composable depending on our needs.
 */
export const SectionCardList: React.FC<SectionCardListProps> = ({
  children,
  heading,
  tooltipContent,
  subheading,
}) => {
  return (
    <div className="SectionCardList lg:flex lg:items-start lg:flex-row lg:space-between lg:gap-comfy-xl">
      <div className="Section__labels mb-comfy-xs shrink-0">
        <div className="flex items-center label-potent label-md gap-snug-lg label-neutral-mild">
          <h2 className="label-potent label-md label-neutral-mild">
            {heading}
          </h2>
          {tooltipContent && (
            <Tooltip>
              <TooltipTrigger>
                <button
                  type="button"
                  className="SectionCardList__tticon flex items-center justify-center"
                  aria-label="Additional information"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <ArkIcon iconName="info-circle" />
                </button>
              </TooltipTrigger>
              <TooltipContent
                className="label-md lg:label-lg"
                alignOffset={-12}
                onPointerDownOutside={(e) => {
                  e.preventDefault();
                }}
              >
                {tooltipContent}
              </TooltipContent>
            </Tooltip>
          )}
        </div>
        {subheading && (
          <span className="label-moderate label-lg label-neutral-amplified">
            {subheading}
          </span>
        )}
      </div>
      <div className="SectionCardList__cards w-full md:ml-auto flex flex-col gap-comfy-xs">
        {children}
      </div>
    </div>
  );
};
